// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "td, th {\n    padding: 8px 8px 8px 15px;\n}\n\nthead tr {\n    border-bottom: 2px solid #d3d3d3;\n}\n\ntbody tr {\n    border-bottom: 1px solid #d3d3d3;\n}\n\ntd div {\n    margin-top: 4px;\n}\n\ntd span {\n    margin-left: 3px;\n}", ""]);
// Exports
module.exports = exports;
